const state = {
    masterEmailgroup: [],
    groupsBased: [],
    journalType: [],
    journalHeaderList: [],
    journalLineList: [],
    journalPlanSchemeList: [],
    hierarchyMasterHeaderList: {},
    hierarchyMasterLineItemList: {},
    hierarchyHeaderItem: {},
    targetPlanningHeaderList: [],
    targetPlanningLineList: [],
    masterEmailGropDropDown: [],
    masterTargetDeploymentDropDown: {
      audience: [],
      division: [],
      channel: [],
      category: [],
      subCategory: [],
      mode: [],
      behaviour: [],
    },
    targetDeploymentHeaderList: [],
    targetDeploymentLineDynamicHeaderList: [],
    targetDeploymentLineDynamicList: [],
  };
  
  export default state;
  